import "kwp-site/styles/main.scss";

if (module.hot) {
    module.hot.accept();
}

const requireAll = (requireContext) => {
    return requireContext.keys().map(requireContext);
};

/**
 * Loads modules from the parent & child `require.context` results.
 * Child modules replace parent modules if present
 *
 * @param {*} parentContext `require.context` output
 * @param {*} childContext `require.context` output
 * @param {*} filenameEndsWith filters blocks to those whose filenames end with a string (excludes extension)
 * @returns Array of `require.context` response objects
 */
const getNestedModules = (
    parentContext,
    childContext,
    filenameEndsWith = false
) => {
    let modules = {};
    [parentContext, childContext].forEach((context) => {
        context
            .keys()
            .filter((filename) => {
                return filenameEndsWith == false
                    ? true
                    : typeof filename === "string"
                    ? filename.match(filenameEndsWith + "$") == filenameEndsWith
                    : false;
            })
            .forEach((filename) => {
                modules[filename] = context(filename);
            });
    });
    return modules;
};

const requireModules = (modules) => {
    Object.keys(modules).forEach(
        (key) =>
            typeof modules[key].default === "function" && modules[key].default()
    );
};

///////////
// UTILS //
///////////
const utils = getNestedModules(
    require.context("kwp-core/scripts/utils", true, /^\.\/.*$/),
    require.context("kwp-site/scripts/utils", true, /^\.\/.*$/),
    false
);

////////////////
// COMPONENTS //
////////////////
const components = getNestedModules(
    require.context("kwp-core/scripts/components", true, /^\.\/.*$/),
    require.context("kwp-site/scripts/components", true, /^\.\/.*$/),
    false
);

////////////
// BLOCKS //
////////////
const blocks = getNestedModules(
    require.context("kwp-core/blocks", true, /^\.\/.*$/),
    require.context("kwp-site/blocks", true, /^\.\/.*$/),
    "/scripts/block"
);
////////////////
// POST TYPES //
///////////////
const postTypes = getNestedModules(
    require.context("kwp-core/post-types", true, /^\.\/.*$/),
    require.context("kwp-site/post-types", true, /^\.\/.*$/),
    "/scripts/post-type"
);

document.addEventListener("DOMContentLoaded", () => {
    requireModules(utils);
    requireModules(blocks);
    requireModules(postTypes);
    requireModules(components);
});
